module.exports = __webpack_public_path__ + "img/battery-notify.9255709b.svg";